import React from 'react'
import StaffSection from '../components/staff/StaffSection'

const About = () => {
  return (
    <div>
      <div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at orci
          et mauris iaculis accumsan et eu lorem. Suspendisse odio ante, viverra
          ac ornare et, aliquam vitae purus. Pellentesque vestibulum, dolor sit
          amet ornare bibendum, odio tellus lacinia odio, ac pharetra turpis
          tortor nec justo. In hac habitasse platea dictumst. In hac habitasse
          platea dictumst. Morbi nec mollis nibh, vel rhoncus sem. Donec
          sollicitudin finibus mauris id tempus. Curabitur ultricies vehicula
          lacus sed pretium. Aliquam ut bibendum urna, a interdum turpis.
          Praesent eu dolor et diam bibendum finibus. Lorem ipsum dolor sit
          amet, consectetur adipiscing elit. Mauris laoreet eros nec elit
          maximus auctor. Quisque id est enim. Praesent eleifend tristique
          lectus, vel tincidunt elit scelerisque non. Cras sagittis risus et
          blandit iaculis. Fusce eget hendrerit purus.
          <br />
          <br /> Ut dictum odio sit amet consequat blandit. In hac habitasse
          platea dictumst. Praesent venenatis in libero ac egestas. Integer
          tempor enim sed lorem mattis, non vestibulum tortor condimentum. Nam
          id lorem nec dui laoreet fermentum vitae non felis. Quisque quis neque
          rutrum eros scelerisque dapibus. Proin rutrum egestas sollicitudin.
          Curabitur elementum finibus nulla, consectetur euismod sem hendrerit
          ac. Sed pretium dignissim accumsan. Phasellus eget elit nec mauris
          varius scelerisque. Sed malesuada sed massa sit amet tristique. Nam
          sed maximus lacus.
        </p>
      </div>
      <StaffSection />
    </div>
  )
}

export default About
